import React from 'react';
import { Alert, Snackbar } from '@mui/material';

interface WebSocketStatusProps {
  isConnected: boolean;
  error: string | null;
}

export const WebSocketStatus: React.FC<WebSocketStatusProps> = ({ isConnected, error }) => {
  return (
    <>
      <Snackbar open={!isConnected} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert severity="warning">
          {error || 'Disconnected from server - attempting to reconnect...'}
        </Alert>
      </Snackbar>
      <Snackbar
        open={isConnected}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="success">Connected to server</Alert>
      </Snackbar>
    </>
  );
};
